import { Routes, Route, Navigate } from 'react-router-dom';
import SiteHeader from './components/SiteHeader';
import SiteFooter from './components/SiteFooter';
import Landing from './pages/Landing';
import Scorecard from './pages/Scorecard';
import Results from './pages/Results';
import Admin from './pages/Admin';
import AdminSubmission from './pages/AdminSubmission';
import QuestionnaireList from './pages/admin/QuestionnaireList';
import QuestionnaireEditor from './pages/admin/QuestionnaireEditor';
import QuestionnaireImport from './pages/admin/QuestionnaireImport';

export default function App() {
  return (
    <>
      <SiteHeader />
      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/scorecard" element={<Navigate to="/scorecard/ai-readiness" replace />} />
          <Route path="/scorecard/:slug" element={<Scorecard />} />
          <Route path="/results/:token" element={<Results />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/admin/submissions/:token" element={<AdminSubmission />} />
          <Route path="/admin/questionnaires" element={<QuestionnaireList />} />
          <Route path="/admin/questionnaires/new" element={<QuestionnaireEditor />} />
          <Route path="/admin/questionnaires/import" element={<QuestionnaireImport />} />
          <Route path="/admin/questionnaires/:id" element={<QuestionnaireEditor />} />
          <Route path="*" element={<Landing />} />
        </Routes>
      </main>
      <SiteFooter />
    </>
  );
}
